<div class="mega-menu" #megaMenu aria-label="mega menu">
  <div class="categories-dropdown">
    <button
      class="heading-categories"
      #seeAllBtnRef
      faroAction="megamenu see all section"
      (click)="handleSeeAllBtn()"
    >
      <span class="ui-label-m-bold">See all {{ menuSection()?.menuName }}</span>
      <rds-icon icon="arrow_right" namespace="filled"></rds-icon>
    </button>

    @if (isLoading()) {
      <ul class="skeleton-categories" aria-hidden="true">
        @for (width of skeletonCategoryWidths; track $index) {
          <li>
            <inexp-skeleton [width]="width" height="0.9rem" />
          </li>
        }
      </ul>
    } @else {
      <ul role="menu" aria-label="categories">
        @for (menuCategory of sortedCategories(); track menuCategory.category) {
          <li
            role="menuitem"
            (click)="onCategoryClicked(menuCategory)"
            (keydown.enter)="onCategoryClicked(menuCategory)"
            tabindex="0"
            #categoryItemRef
            faroAction="megamenu category"
            class="ui-label-m-bold"
            [class.active]="selectedCategory() === menuCategory"
            [attr.aria-current]="selectedCategory() === menuCategory"
          >
            {{ menuCategory.category }}
          </li>
        }
      </ul>
    }
  </div>
  @if (isLoading()) {
    <div class="items-dropdown">
      <div class="skeleton-heading-items" aria-hidden="true">
        <inexp-skeleton width="40%" height="1.125rem" />
      </div>
      <div class="grid-listing">
        @for (item of skeletonItems; track $index) {
          <div class="grid-item skeleton-item" aria-hidden="true">
            <inexp-skeleton width="55%" height="1rem" />
            <div class="skeleton-item-desc">
              <inexp-skeleton width="100%" height="0.75rem" />
              <inexp-skeleton width="80%" height="0.75rem" />
            </div>
          </div>
        }
      </div>
    </div>
  } @else if (selectedCategory()) {
    <div class="items-dropdown">
      @if (selectedCategory().items.length === 0) {
        <p>No results found</p>
      } @else {
        <button
          class="heading-items"
          #seeAllInBtnRef
          faroAction="megamenu see all in category"
          (click)="handleSeeAllInBtn()"
        >
          <span class="ui-label-m-bold">See all in {{ selectedCategory()?.category }}</span>
          <rds-icon icon="arrow_right" namespace="filled"></rds-icon>
        </button>
        <div class="grid-listing">
          @for (item of selectedCategory().items; track item.id; let last = $last) {
            <button
              class="grid-item"
              (click)="onItemClicked(item)"
              (keydown.tab)="onItemFocus(last)"
              [attr.aria-label]="item.displayName"
              faroAction="megamenu offering item"
            >
              <div class="item-header">
                <div class="title">
                  <span class="ui-label-m-bold">{{ item.displayName }}</span>
                  <rds-icon icon="arrow_right" namespace="filled"></rds-icon>
                </div>
              </div>
              <div class="item-description">
                <p class="ui-label-s">{{ item.description }}</p>
              </div>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
